/*******************************************************************************
 * Check */
/**
 * @ngdoc   run
 * @module  csm.books.com.returnItems
 * @name    csm.books.com.returnItems.run:Check
 * @description
 * Creates a data object constructor by setting default values and functions on
 * the prototype. The data will be initialized with the `entryDate`.
 *******************************************************************************/
/* @ngInject */ export function ReturnItemsRunCheck(Data, LocalDateSerializer, SERVER) {
  /*****************************************************************************
   * Constructor
   *****************************************************************************/
  Data.Check = function (entryDate) {
    var check = Object.assign(Object.create(Data.Check.prototype), {});
    check.entryDate = entryDate;

    return check;
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  Data.Check.prototype = {
    type: SERVER.BooksDBConstants.LET_CHECK,
    entryDate: null,
    amount: 0,
    entityID: NaN,
    paidTo: NaN,
    handwritten: false,
    bankAccountID: NaN,
    checkNumber: 0,

    /***************************************************************************
     * toJSON */
    /**
     * Since all the properties on the prototype may not be serialized, we want
     * the object to contain a direct representation of the properties when it is
     * converted to JSON for the server.
     ***************************************************************************/
    toJSON: function () {
      var result = {};
      for (var key in this) result[key] = this[key];

      return result;
    }
  };
}
